// for featured suppliers page
let page = 1
let page_size = 9
let isLastPage = false
let $container = ''
function initInfiniteScroll() {
  $container = $('#product-list').infiniteScroll({
    path: function() {
      const activeTab = $('.featured-supplier-tab .nav .active')
      let params = `&${$(activeTab).attr('data-tab-key')}=${$(activeTab).attr('data-tab-value') ? $(activeTab).attr('data-tab-value').replace('&', '%26') : ''}`
      $.each($('#featured-supplier-wrapper #selected-item .selected'), function() {
        params += `&${$(this).attr('data-item-key')}=${$(this).attr('data-item-value')}`
      })
      return isLastPage ? '' : `https://api.marcothepolo.com/api/v1/sp-supplier/filter-choice?page=${page}&page_size=${page_size}${params}`
    },
    responseType: 'json',
    fetchOptions: function() {
      return {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      };
    },
    responseBody: 'json',
    history: false,
    scrollThreshold: 150,
    loadOnScroll: true,
    checkLastPage: true,
    status: '.page-load-status',
    debug: true
  });
}

function loadSupplierList(body) {
  if(body && body.data) {
    const { list, current_page, last_page } = body.data
    if(current_page === last_page || current_page > last_page) {
      isLastPage = true
    } else {
      page ++
    }
    if(list?.length > 0) {
      let html = ''
      list.forEach(item => {
        const { avatar_img, establish_time, office_area, product_num, staff_num, store_name_en, supplier_name_en, collection_handle, new_product_list } = item
        const storeName = store_name_en || supplier_name_en

        let itemHtml = ''
        itemHtml += '<div class="supplier-info d-flex justify-content-between">'
          + '<div class="avatar-text d-flex align-items-center">'
          + '<a class="avatar-img-wrapper" onClick="Shopify.jumpToPage(\'/collections/' + collection_handle + '\')" href="#">'
          + (avatar_img ? '<img class="avatar-img" src="' + avatar_img + '">' : '')
          + '</a>'
          + '<div class="text ml-1">'
          + '<a onClick="Shopify.jumpToPage(\'/collections/' + collection_handle + '\')" href="#">' + storeName + '</a>'
          + '<div class="info"><span>' + (establish_time ? `<span>${establish_time} yrs</span>` : '') + (staff_num ? `<span> ${establish_time ? '&middot; ' : ''}${staff_num} staff </span>` : '' ) + '<span class="d-none d-md-inline-block">' + (office_area ? ` &middot; ${office_area} ㎡` : '') + '</span></span></div>'
          + '</div>'
          + '</div>'
          + '<a onClick="Shopify.jumpToPage(\'/collections/' + collection_handle + '\')" href="#">'
          + '<button class="btn btn-primary">Shop All</button>'
          + '</a>'
          + '</div>'
        
        let productHtml = ''
        if(new_product_list && new_product_list.length > 0) {
          productHtml = '<div class="supplier-product-list row mt-2">'
          new_product_list.forEach(product => {
            const { image_src, price_range, handle, special_tag } = product
            productHtml += '<div class="grid-item col-xs-4 col-sm-4 col-md-4 col-xl-4">'
              + '<div class="product product-card product-inner">'
              + '<a onClick="Shopify.jumpToPage(\'/products/' + handle + '\')" href="#">'
              + '<img src="' + image_src + '">'
              + (special_tag ? '<span class="tag label-menu ' + (special_tag === 'New' ? '_new' : '_hot') + '">' + special_tag + '</span>' : '')
              + '</a>'
              + '<span class="product-price">$' + price_range + '</span>'
              + '</div>'
              + '</div>'
          })
          productHtml += '</div>'
        }
        
        html = '<div class="featured-supplier-product-item card">' + itemHtml + productHtml + '</div>'
        if(product_num > 5) {
          $('.featured-supplier-product-item-wrapper').append(html)
        }
        
        // set image height
        $.each($('.featured-supplier-product-item .supplier-product-list .product-card'), function(index) {
          $(this).find('a').height($(this).width())
        })
      })
    } else {
      $('.featured-supplier-product-item-wrapper').html('<div class="w-100 text-center">No result, please change the filter</div>')
    }
  }
}

function getSupplierFilter () {
  $.ajax({
    type: "GET",
    url: `https://api.marcothepolo.com/api/v1/sp-supplier/supplier-filter`,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    success: function(data) {
      if(data.code === 10000 && data.data && data.data) {
        const filterList = data.data
        let tabHtml = '', itemTabHtml = '', firstTabValue = ''
        filterList.forEach(({text, value, children}, index) => {
          const tabId = text.split('&')[0].split(' ')[0]
          if(index === 0) {
            firstTabValue = text
          }
          tabHtml += '<li><a class="' + (index === 0 ? 'active' : '') + '" id="' + tabId + '-tab" href="#' + tabId + '" data-tab-key="' + value + '" data-tab-value="' + text + '" data-toggle="tab" role="tab">' + text.replace('Fashion ', '') + '</a></li>'
          let itemListLgHtml = '<div class="d-none d-md-block mt-1">'
          let itemListSmHtml = '<div class="sm-selected-wrapper mt-1 d-md-none">'
          let moreItemHtml = ''
          children.forEach((itemName, itemNameIndex) => {
            if(itemName.children && itemName.children.length > 0) {
              let itemHtml = '', itemSmHtml = '', moreItemOptionHtml = ''
              itemName.children.forEach((item, itemIndex) => {
                if(item) {
                  itemHtml += '<span id="' + `${tabId}-${itemNameIndex}-${itemIndex}` + '" data-item-type="' + `${tabId}-${itemNameIndex}` + '" data-item-key="' + itemName.value + '" data-item-value="' + item + '" class="ml-2">' + item + '</span>'
                  itemSmHtml += (itemIndex === 0 ? '<option value="" data-item-type="' + `${tabId}-${itemNameIndex}` + '">All</option>' : '') + '<option id="' + `${tabId}-${itemNameIndex}-${itemIndex}` + '" data-item-type="' + `${tabId}-${itemNameIndex}` + '" data-item-key="' + itemName.value + '" data-item-value="' + item + '" value="' + item + '">' + item + '</option>'
                  moreItemOptionHtml += (itemIndex === 0 ? '<option value="" data-item-type="' + `${tabId}-${itemNameIndex}` + '">All</option>' : '') + '<option id="' + `${tabId}-${itemNameIndex}-${itemIndex}` + '" data-item-type="' + `${tabId}-${itemNameIndex}` + '" data-item-key="' + itemName.value + '" data-item-value="' + item + '" value="' + item + '">' + item + '</option>'
                }
              })
              if(itemName.more_filters) {
                moreItemHtml += '<select><option value="" disabled selected hidden>' + itemName.text + '</option>' + moreItemOptionHtml + '</select>'
              } else {
                itemListLgHtml += '<div class="filter-item d-flex mb-1">'
                  + '<h4>' + itemName.text + ':</h4>'
                  + '<div>' + itemHtml + '</div></div>'
              }
              itemListSmHtml += '<select class="form-control"><option value="" disabled selected hidden>' + itemName.text + '</option>' + itemSmHtml + '</select>'
            }
          })
          if(children.filter(item => item.more_filters).length > 0) {
            itemListLgHtml += '<div class="filter-item d-flex mb-1">'
              + '<h4>More Filters:</h4>'
              + '<div class="select-wrapper">'
              + moreItemHtml
              + '</div></div>'
          }
          itemListLgHtml += '</div>'
          itemListSmHtml += '</div>'
          itemTabHtml += '<div class="fade ' + (index === 0 ? 'active show' : '') + '" id="' + tabId + '">' + itemListLgHtml + itemListSmHtml + '</div>'
        })
        $('#featured-supplier-wrapper .featured-supplier-tab ul').html(tabHtml)
        $('#featured-supplier-wrapper .featured-supplier-tab').after(itemTabHtml)
        $('#featured-supplier-wrapper .featured-supplier-filter').show()
        getSupplierProductList(firstTabValue)
      }
    }
  })
}

let selectedIdArr = []
$('#featured-supplier-wrapper').on('click', '.filter-item span', function() {
  const id = $(this).attr('id')
  const itemKey = $(this).attr('data-item-key')
  const itemValue = $(this).attr('data-item-value')
  let activeItem = $(this).parent().find('.active')
  if(selectedIdArr.includes(id)) {
    const index = selectedIdArr.indexOf(id)
    selectedIdArr.splice(index, 1)
    $(this).removeClass('active')
    $.each($('#featured-supplier-wrapper #selected-item .selected'), function() {
      if($(this).attr('data-id') === id) {
        $(this).remove()
      }
    })
  } else if(activeItem.length > 0) {
    let activeItemId = $(this).parent().find('.active').first().attr('id')
    const index = selectedIdArr.indexOf(activeItemId)
    selectedIdArr.splice(index, 1)
    activeItem.removeClass('active')
    $.each($('#featured-supplier-wrapper #selected-item .selected'), function() {
      if($(this).attr('data-id') === activeItemId) {
        $(this).remove()
      }
    })
    selectedIdArr.push(id)
    $(this).addClass('active')
    $('#featured-supplier-wrapper #selected-item').append('<span class="selected mr-1 mb-1" data-id="' + id + '" data-item-key="' + itemKey + '" data-item-value="' + itemValue + '">' + $(this).text() + '<span class="item-close">X</span></span>')
  } else {
    selectedIdArr.push(id)
    $(this).addClass('active')
    $('#featured-supplier-wrapper #selected-item').append('<span class="selected mr-1 mb-1" data-id="' + id + '" data-item-key="' + itemKey + '" data-item-value="' + itemValue + '">' + $(this).text() + '<span class="item-close">X</span></span>')
  }
  resetProductList()
})

$('#featured-supplier-wrapper').on('change', '.featured-supplier-filter select', function() {
  const $selectOption = $(this).find('option:selected')
  const id = $selectOption.attr('id')
  const itemKey = $selectOption.attr('data-item-key')
  const itemValue = $selectOption.attr('data-item-value')
  const itemType = $selectOption.attr('data-item-type')
  let activeItemIndex = -1, activeItemId = ''
  selectedIdArr.forEach((item, index) => {
    if(item.indexOf(itemType) > -1) {
      activeItemIndex = index
      activeItemId = item
    }
  })
  if(activeItemIndex > -1) {
    selectedIdArr.splice(activeItemIndex, 1)
    $.each($('#featured-supplier-wrapper #selected-item .selected'), function() {
      if($(this).attr('data-id') === activeItemId) {
        $(this).remove()
      }
    })
  }
  if($(this).val()) {
    $(this).addClass('active')
    selectedIdArr.push(id)
    $('#featured-supplier-wrapper #selected-item').append('<span class="selected mr-1 mb-1" data-id="' + id + '" data-item-key="' + itemKey + '" data-item-value="' + itemValue + '">' + itemValue + '<span class="item-close">X</span></span>')
  } else {
    $(this).removeClass('active')
    $(this).val('')
  }
  resetProductList()
})

$('#featured-supplier-wrapper #selected-item').on('click', '.item-close', function() {
  const id = $(this).parent().attr('data-id')
  const index = selectedIdArr.indexOf(id)
  selectedIdArr.splice(index, 1)
  $(this).parent().remove()
  $.each($('.featured-supplier-filter .show span'), function() {
    if($(this).attr('id') === id) {
      $(this).removeClass('active')
    }
  })
  $.each($('.featured-supplier-filter .show select option'), function() {
    if($(this).attr('id') === id) {
      $(this).parent().removeClass('active')
      $(this).parent().val('')
    }
  })
  resetProductList()
})

function resetSelected(tabValue) {
  selectedIdArr = []
  $('#featured-supplier-wrapper #selected-item').html('')
  $.each($('.featured-supplier-filter .show span'), function() {
    $(this).removeClass('active')
  })
  $.each($('.featured-supplier-filter .show select option'), function() {
    $(this).parent().removeClass('active')
    $(this).parent().val('')
  })
  resetProductList(tabValue)
}

function resetProductList (tabValue) {
  page = 1
  isLastPage = false
  $('#featured-supplier-wrapper #product-list').html('')
  $('#featured-supplier-wrapper #selected-item .selected').length > 0 ? $('#featured-supplier-wrapper .selected-item').show() : $('#featured-supplier-wrapper .selected-item').hide()
  $container.infiniteScroll('destroy')
  initInfiniteScroll()
  getSupplierProductList(tabValue)
}

$('#featured-supplier-wrapper .clear').click(function() {
  resetSelected()
})

// change tab
$('#featured-supplier-wrapper .featured-supplier-tab').on('click', 'a', function() {
  resetSelected($(this).attr('data-tab-value'))
})

function getSupplierProductList(tabValue) {
  const activeTab = $('.featured-supplier-tab .nav .active')
  const activeTabValue = tabValue ? tabValue : activeTab.attr('data-tab-value')
  let params = `&${$(activeTab).attr('data-tab-key')}=${activeTabValue ? activeTabValue.replace('&', '%26') : ''}`
  $.each($('#featured-supplier-wrapper #selected-item .selected'), function() {
    params += `&${$(this).attr('data-item-key')}=${$(this).attr('data-item-value')}`
  })
  $.ajax({
    type: "GET",
    url: `https://api.marcothepolo.com/api/v1/sp-supplier/filter-choice?page=${page}&page_size=${page_size}${params}`,
    dataType: "json",
    success: function(data) {
      loadSupplierList(data)
    }
  })
}

$(document).ready(function(){
  const handle = $('#featured-supplier-wrapper').attr('data-handle')
  if(handle === 'featured-suppliers') {
    getSupplierFilter()
    window.onresize = function() {
      $.each($('.featured-supplier-product-item .supplier-product-list .product-card'), function(index) {
        $(this).find('a').height($(this).width())
      })
    }
    // get supplier product list
    initInfiniteScroll()
    $container.on('load.infiniteScroll', function(event, body, path, response) {
      loadSupplierList(body)
    })
  }
})